@let q = question();
<h3>{{ q.title }}</h3>
@if (q.subtitle) {
  <p>{{ q.subtitle }}</p>
}
@if (form.get(question().title)?.invalid) {
  <div class="error">
    @for (error of getErrors(); track error) {
      <p>{{ error }}</p>
    }
  </div>
}
<div [formGroup]="form" class="grid">
  @for (option of q.options; track option) {
    <div class="grid-element">
      <input
        type="checkbox"
        [checked]="form.get(q.title)?.value.includes(option)"
        (change)="toggleOption(option.id)"
        [id]="q.id + ' ' + option.id"
      />
      <label [for]="q.id + ' ' + option.id">{{ option.label }}</label>
    </div>
  }
  @if (q.wildcard) {
    <div class="grid-element">
      <input
        type="checkbox"
        [checked]="checked"
        (change)="toggleWildcardOption($event)"
        id="{{ q.title }}{{ q.wildcard.label }}"
      />
      <label for="{{ q.title }}{{ q.wildcard.label }}">{{ q.wildcard.label }}</label>
      <input
        type="text"
        id="{{ q.title }}{{ q.wildcard.label }}: more info"
        placeholder="{{ q.wildcard.placeholder }}"
        class="wildcard-input"
        [value]="additionalInfo"
        [class.invalid]="form.get(formControlName)?.errors?.['emptyWildcard']"
        (input)="updateAdditionalInfo($event)"
      />
      @if (form.get(formControlName)?.errors?.["emptyWildcard"]) {
        <div i18n class="error">This field cannot be empty</div>
      }
    </div>
  }
</div>
